import { IListingBookingRequestQuery } from 'app/library/course-catalog-listing/interfaces/listing-booking-request.query.interface';
import { IListingBookingRequestGroupQuery } from 'app/library/course-catalog-listing/interfaces/listing-booking-request-group.query.interface';
import { IListingBookingRequestsResponseQuery } from 'app/library/course-catalog-listing/interfaces/listing-booking-requests-response.query.interface';

export class ListingBookingRequestsResponse {
    data: IListingBookingRequestQuery[];
    groups: IListingBookingRequestGroupQuery[];
    pagination: {
        number_of_pages: number;
        number_of_results: number;
    };
    openBookingRequestCount: number;
    openBookingRequestCountUserCanDecide: number;
    listingStartDate: string | null;
    listingEndDate: string | null;

    constructor(query: IListingBookingRequestsResponseQuery) {
        this.data = query?.data || [];
        this.groups = query?.groups || [];
        this.pagination = query?.pagination || {
            number_of_pages: 0,
            number_of_results: 0,
        };
        this.openBookingRequestCount = query?.open_booking_request_count ?? query?.listing?.open_booking_request_count ?? 0;
        this.openBookingRequestCountUserCanDecide = query?.open_booking_request_count_user_can_decide ?? query?.listing?.open_booking_request_count_user_can_decide ?? 0;
        this.listingStartDate = query?.listing?.start_date ?? null;
        this.listingEndDate = query?.listing?.end_date ?? null;
    }
}
